import * as d3 from 'd3'

export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.circle   = json.circle
      this.title    = json.title
      this.value    = json.value
      this.columns  = json.columns

      this.keys     = json.keys
      this.filters  = json.filters
      this.sundries  = json.sundries
      

      // Revision Values
      if(!this.value.main.visible) this.value.main.visible = 'Y'
      if(!this.value.sub.visible) this.value.sub.visible = 'Y'
    },

  }
}